import axios from 'axios';
import React, { FC, useEffect, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_JOBS, JOBS_APPLICATION_URL, MOBIZ_API_URL } from '../../constants/paths/api';
import { clientIdConfig } from '../../helpers/mobizHelpers/configurations';
import { getQueryParam } from '../../helpers/url/urlHelpers';
import Accordion from '../accordion';
import { Tab, Tabs } from '../base/tabs/tabs';
import * as StyledAvailableJobs from './availableJobs.styles';
import PlaceHolderLoader from './placeholderLoading/placeholderLoading';

interface Props {}

const AvailableJobs: FC<Props> = () => {
	const { t, i18n } = useTranslation('common');
	const language = i18n.language;

	const [jobs, setJobs] = useState([]);
	const [summerJobs, setSummerJobs] = useState([]);
	const [loading, setLoading] = useState(true);
	const type = getQueryParam('tegund') || getQueryParam('type');
	const [activeTab, setActiveTab]: [Number, any] = useState(type === 'sumar' ? 1 : 0);
	const onTabClick = tab => {
		setActiveTab(tab);
	};
	const highlightId = Number(getQueryParam('id') || getQueryParam('starf') || getQueryParam('job'));

	useEffect(() => {
		setLoading(true);
		axios(
			`${MOBIZ_API_URL}${AVAILABLE_JOBS}?language=${encodeURIComponent(language)}`,
			clientIdConfig
		).then(res => {
			const regJobs = [];
			const sJobs = [];
			res.data.map(item => {
				if (item.rcAdvertTitle.toLowerCase().includes('sumar')) {
					if (item.rcAdvertID === highlightId) setActiveTab(1);
					sJobs.push({
						Values: {
							// Title: item.rcAdvertTitle.substring(15, item.rcAdvertTitle.length),
							Title: item.rcAdvertTitle,
							Content: item.rcAdvertAdText,
						},
						urlRedirect: item.rcAdvertUrl,
						id: item.rcAdvertID,
					});
				} else
					regJobs.push({
						Values: {
							// Title: item.rcAdvertTitle.substring(15, item.rcAdvertTitle.length),
							Title: item.rcAdvertTitle,
							Content: item.rcAdvertAdText,
						},
						urlRedirect: item.rcAdvertUrl,
						id: item.rcAdvertID,
					});
				return null;
			});
			setLoading(false);
			setJobs(regJobs.reverse());
			setSummerJobs(sJobs.reverse());
		});
	}, [language, highlightId]);

	const applyForJobClick = url => {
		const win = window.open(`${JOBS_APPLICATION_URL}${url}`, '_blank');
		win.focus();
	};

	if (loading) return <PlaceHolderLoader searchLoading />;

	return (
		<StyledAvailableJobs.Wrapper>
			{summerJobs.length > 0 && (
				<Tabs>
					<Tab active={activeTab === 0} onClick={onTabClick.bind(null, 0)}>
						{t('fullTime')}
					</Tab>
					<Tab active={activeTab === 1} onClick={onTabClick.bind(null, 1)}>
						{t('summerJobs')}
					</Tab>
				</Tabs>
			)}
			<StyledAvailableJobs.ContentWrapper>
				<AnimateHeight
					duration={400}
					style={{ opacity: activeTab === 0 ? 1 : 0 }}
					height={activeTab === 0 ? 'auto' : 0}>
					<Accordion
						items={jobs}
						buttonString={t('applyForJob')}
						buttonOnClick={applyForJobClick}
						highlightId={highlightId}
					/>
				</AnimateHeight>
				<AnimateHeight
					duration={400}
					style={{ opacity: activeTab === 1 ? 1 : 0 }}
					height={activeTab === 1 ? 'auto' : 0}>
					<Accordion
						items={summerJobs}
						buttonString={t('applyForJob')}
						buttonOnClick={applyForJobClick}
						highlightId={highlightId}
					/>
				</AnimateHeight>
			</StyledAvailableJobs.ContentWrapper>
		</StyledAvailableJobs.Wrapper>
	);
};

export default AvailableJobs;
